import { datadogLogs } from '@datadog/browser-logs';
import { datadogConfig } from './config';
var redactEmail = function (payload) { return payload.replace(/email=[^&]*/, 'email=REDACTED'); };
var redactName = function (payload) { return payload.replace(/name=[^&]*/, 'name=REDACTED'); };
var redactToken = function (payload) { return payload.replace(/access_token=[^&]*/, 'access_token=REDACTED'); };
var redactPII = function (payload) { return redactToken(redactName(redactEmail(payload))); };
export var initializeLogger = function () {
    datadogLogs.init({
        clientToken: datadogConfig.clientToken,
        site: datadogConfig.site,
        service: datadogConfig.serviceId,
        forwardErrorsToLogs: false,
        sampleRate: 100,
        beforeSend: function (log) {
            var _a, _b, _c, _d, _e;
            // @ts-ignore
            if ((_b = (_a = log === null || log === void 0 ? void 0 : log.error) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.data) {
                // @ts-ignore
                log.error.config.data = undefined;
            }
            if ((_c = log === null || log === void 0 ? void 0 : log.view) === null || _c === void 0 ? void 0 : _c.url) {
                log.view.url = redactPII(log.view.url);
            }
            if ((_d = log === null || log === void 0 ? void 0 : log.http) === null || _d === void 0 ? void 0 : _d.url) {
                log.http.url = redactPII(log.http.url);
            }
            if ((_e = log === null || log === void 0 ? void 0 : log.view) === null || _e === void 0 ? void 0 : _e.referrer) {
                log.view.referrer = redactPII(log.view.referrer);
            }
        },
    });
};
//# sourceMappingURL=index.js.map